const validContactTypes = ["WhatsApp", "Telefone fixo"];

const getContactType = (value) => {
  switch (value) {
    case "0dfbfbff-1ca4-4cca-a608-cb4208c6fa53":
      return "Celular/WhatsApp";
    case "4df1231f-4eda-4530-b80e-bff2e0ca2594":
      return "Email";
    case "52137066-10a0-4eb2-aff3-d67f318483aa":
      return "Telefone fixo";
    case "77c27ebd-845c-4e4b-97d6-244f2045a1db":
      return "Ramal do consultório";
    case "b31614ea-6a2e-4532-b1e5-614d35db41b5":
      return "Ramal da secretária";
    case "e54601fa-68b9-4c06-80e0-541bf44faba8":
      return "Secretária";
    default:
      return "Not found";
  }
};

export const getContacts = (unit) => {
  return (
    unit.contacts
      .filter((contact) =>
        validContactTypes.some(
          (c) => c === getContactType(contact.contact_type_id)
        )
      )
      .map((contact) => ({
        type: getContactType(contact.contact_type_id),
        value: contact.value.value || "",
      })) || []
  );
};
